// extracted by mini-css-extract-plugin
export default {"multiFilters":"index_multiFilters__3sOTc","filter":"index_filter__1KV23 typography_bodyFont__3RHTp","filterLabel":"index_filterLabel__1O2f4"};